module.exports = __webpack_public_path__ + "img/farming_11.b6e073e6.png";